import { messages as validation } from "vee-validate/dist/locale/en.json";
import { ProfileLinkType } from "@scrile/api-provider/dist/api/ProfileLinksProvider";
import { VipStatus } from "@scrile/api-provider/dist/api/UserProvider";
import { countryList } from "@/locales/properNouns";
import messages from "./json/en.json";

export default {
  pl: {
    word: "{n} {word} | {n} {word}s",
  },
  validation: {
    ...validation,
    credit_card: "The {_field_} field must be a valid credit card number",
    required_select: validation.required,
  },
  notificationsText: {
    liked: "{screenName} liked your {type}",
    followed: "{screenName} followed you",
    subscribed: "{screenName} subscribed to you for {price}",
    upgradeSubscription: "{screenName} upgrade subscription to you. Now the subscription level is {price}",
    soldPost: "{screenName} bought your post for {price}",
    soldAttachment: "{screenName} bought your attach for {price}",
    soldEvent: "{screenName} has booked your event {date} for {price}",
    eventPublished: "Upcoming event by {screenName}!",
    eventStarted: "The event has started",
    eventCancelled: "{screenName} canceled the event",
    sendReview: "{screenName} left a comment: {review}",
    sendMentionedReview: "{screenName} replied you: {review}",
    appointmentRequested: "{screenName} requested {appointmentType} with you",
    appointmentApproved: "{screenName} accepted {appointmentType} with you",
    appointmentRejected: "{screenName} declined {appointmentType} with you",
    appointmentCancelled: "{screenName} canceled {appointmentType} with you",
    appointmentReminder: "{screenName} {timeLeft} left before appointment",
    appointmentNoResponse:
      "{screenName} didn’t respond to your {appointmentType} request. Money returned to your wallet",
    newUser: "{screenName} is new on Ciaofan - go follow them!",
    creatorServicePurchasedConsumer: "You purchased service “{title}” for {price} from {screenName}",
    creatorServicePurchasedProvider: "{screenName} purchased your service “{title}” for {price}",
  },
  vipStatus: {
    [VipStatus.VIP]: "VIP",
    [VipStatus.EXCLUSIVE_VIP]: "Exclusive VIP",
  },
  profileLink: {
    [ProfileLinkType.FACEBOOK]: "Facebook",
    [ProfileLinkType.INSTAGRAM]: "Instagram",
    [ProfileLinkType.TWITTER]: "X",
    [ProfileLinkType.TIKTOK]: "TikTok",
    [ProfileLinkType.YOUTUBE]: "YouTube",
    [ProfileLinkType.SNAPCHAT]: "Snapchat",
    [ProfileLinkType.PATREON]: "Patreon",
    [ProfileLinkType.ONLYFANS]: "OnlyFans",
    [ProfileLinkType.LINKEDIN]: "LinkedIn",
    [ProfileLinkType.WHATSAPP]: "WhatsApp",
    [ProfileLinkType.TELEGRAM]: "Telegram",
    [ProfileLinkType.EMAIL]: "Email",
  },
  ...messages,
  ...countryList,
};
